import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { api } from "../api";
import { Button, Spinner } from "./ui";

export const telegramMessages: Record<string, string> = {
  referral_invalid: "推广码无效或已停用。请核对推广链接后重新注册。",
  unavailable: "Telegram 登录暂未开放，请使用账号登录或稍后再试。",
  expired: "授权已过期或浏览器状态不匹配，请重新发起 Telegram 登录。",
  cancelled: "已取消 Telegram 授权，你可以重新登录。",
  locked: "该账号已停用，请联系支持人员。",
  failed: "Telegram 授权未完成，请重新尝试。",
};

export function TelegramLogin({ open, referralCode }: { open: boolean; referralCode?: string }) {
  const [status, setStatus] = useState<"loading" | "ready" | "unavailable" | "error">("loading");
  const [retry, setRetry] = useState(0);
  const regionRef = useRef<HTMLElement>(null);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const retryRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (retry > 0 && status !== "loading") {
      if (status === "ready") linkRef.current?.focus();
      else retryRef.current?.focus();
    }
  }, [retry, status]);
  useEffect(() => {
    if (!open) return;
    const controller = new AbortController();
    setStatus("loading");
    void api<{ configured: boolean }>("/api/auth/telegram/config", { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(10_000)]) })
      .then((result) => { if (!controller.signal.aborted) setStatus(result.configured ? "ready" : "unavailable"); })
      .catch(() => { if (!controller.signal.aborted) setStatus("error"); });
    return () => controller.abort();
  }, [open, retry]);
  return <section ref={regionRef} tabIndex={-1} className="telegram-login" aria-label="Telegram 登录与注册">
    <p>使用 Telegram 登录，首次授权将自动创建星河账号。</p>
    {status === "loading" ? <Spinner label="正在检查 Telegram 登录" /> : status === "ready" ?
      <a ref={linkRef} className="button button--solid button--brand" href={referralCode ? `/api/auth/telegram/start?ref=${encodeURIComponent(referralCode)}` : "/api/auth/telegram/start"}><Send aria-hidden="true" />Telegram 登录 / 注册</a> :
      <><p role="status">{status === "unavailable" ? telegramMessages.unavailable : "无法连接登录服务，请检查网络后重试。"}</p><Button ref={retryRef} emphasis="outline" intent="neutral" onClick={() => { regionRef.current?.focus(); setRetry((value) => value + 1); }}>重新检查</Button></>}
    <small>仅使用 Telegram 身份和公开姓名创建账号，无需提供 Telegram 密码。</small>
  </section>;
}
